<template>
  <div class="centered-container">
    <v-card class="elevation-3">
      <div class="title">
        <img src="/scrapingant-logo.png" />
        <p class="lg--text mb-0 fontweight400">Enter new password</p>
        <p
          class="mb-0 xs--text line-height24 fontweight400"
          v-if="loading && !wrong_token && !success"
        >
          Validating token...
        </p>
        <p
          class="mb-0 xs--text line-height24 fontweight400"
          v-if="!loading && !wrong_token && !success"
        >
          Please, enter new password for your ScrapingAnt account.
        </p>
        <p
          class="mb-0 xs--text line-height24 fontweight400 confirmation-message"
          v-if="!loading && !wrong_token && success"
        >
          Password has been changed. Redirecting to dashboard...
        </p>
        <p
          v-if="!loading && wrong_token"
          class="form-error mb-0 xs--text line-height24 fontweight400"
          style="margin-top: 10px"
        >
          Wrong confirmation token. Try to
          <router-link :to="{ name: 'ResetPassword' }"
            >Reset Password</router-link
          >
          for resending confirmation token.
        </p>
      </div>

      <div
        v-if="!loading && !wrong_token && !success"
        class="form"
        v-on:keyup.enter="changeOnEnter"
      >
        <v-col class="pa-0">
          <v-text-field
            v-model="$v.reset_password_form.password.$model"
            :type="showPassword ? 'text' : 'password'"
            :error-messages="passwordErrors"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @input="$v.reset_password_form.password.$touch()"
            @click:append="showPassword = !showPassword"
            label="Password"
          ></v-text-field>
        </v-col>
        <v-col class="pa-0">
          <v-text-field
            v-model="$v.reset_password_form.repeated_password.$model"
            :type="showPasswordOneMoreTime ? 'text' : 'password'"
            :error-messages="OneMoreTimePasswordErrors"
            :append-icon="showPasswordOneMoreTime ? 'mdi-eye' : 'mdi-eye-off'"
            @input="$v.reset_password_form.repeated_password.$touch()"
            @click:append="showPasswordOneMoreTime = !showPasswordOneMoreTime"
            label="Password one more time"
          ></v-text-field>
        </v-col>
        <span class="form-error">{{ error }}</span>
      </div>

      <div
        v-if="!loading && !wrong_token && !success"
        class="actions md-layout md-alignment-center-space-between"
      >
        <v-row class="justify-space-between ma-0">
          <v-col class="pa-0">
            <v-btn color="font" :to="{ name: 'Login' }">Login</v-btn>
          </v-col>
          <v-col class="pa-0" align="end">
            <v-btn color="primary" :disabled="isDisabledForm" @click="change"
              >Change password</v-btn
            >
          </v-col>
        </v-row>
      </div>

      <div class="loading-overlay" v-if="loading">
        <v-progress-circular
          :size="50"
          :width="2"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-card>
  </div>
</template>

<script>
import { required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  name: "ResetPasswordForm",
  data() {
    return {
      loading: false,
      showPasswordOneMoreTime: false,
      wrong_token: false,
      showPassword: false,
      success: false,
      reset_password_form: {
        password: "",
        repeated_password: "",
      },
      error: "",
    };
  },
  validations: {
    reset_password_form: {
      password: {
        required,
        minLength: minLength(6),
      },
      repeated_password: {
        required,
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    OneMoreTimePasswordErrors() {
      const errors = [];
      if (!this.$v.reset_password_form.repeated_password.$dirty) return errors;
      !this.$v.reset_password_form.repeated_password.required &&
        errors.push("Passwords not match :(");
      !this.$v.reset_password_form.repeated_password.sameAsPassword &&
        errors.push("Passwords not match :(");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.reset_password_form.password.$dirty) return errors;
      !this.$v.reset_password_form.password.required &&
        errors.push(
          "Please, enter new password with length of 6 symbols or more"
        );
      !this.$v.reset_password_form.password.minLength &&
        errors.push(
          "Please, enter new password with length of 6 symbols or more"
        );
      return errors;
    },
    isDisabledForm() {
      return (
        this.$v.reset_password_form.password.$error ||
        this.$v.reset_password_form.repeated_password.$error ||
        !this.$v.reset_password_form.password.$dirty ||
        !this.$v.reset_password_form.repeated_password.$dirty
      );
    },
  },
  methods: {
    errors(res) {
      this.error =
        res?.data?.error?.msg ?? "Error occurred. Please, try again.";
    },

    change() {
      this.loading = true;
      this.$store
        .dispatch("auth/set_new_password", {
          password: this.reset_password_form.password,
          token: this.$route.params.token,
        })
        .then(
          () => {
            this.loading = false;
            this.success = true;
            this.$router.replace({ name: "Dashboard" });
          },
          (res) => {
            this.loading = false;
            this.errors(res.response);
          }
        );
    },

    changeOnEnter() {
      if (!this.isDisabledForm) {
        this.change();
      }
    },
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("auth/check_reset_token", this.$route.params.token)
      .then(
        () => {
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.wrong_token = true;
        }
      );
  },
};
</script>

<style scoped lang="scss">
</style>